import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { useApi } from '../../util/lib';
import HtmlHead from '../UI/Head/HtmlHead';

import css from '../RpryEstimation/RpryEstimation.module.css';

export const RpryPayment = () => {
  const [pristine, setPristine] = useState(true);
  const [error, setError] = useState();
  const api = useApi();
  const { paymentId } = useParams();

  useEffect(() => {
    const resolvePayment = async () => {
      try {
        if (!pristine || !paymentId) return;
        setPristine(false);
        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/sdk/payments/${paymentId}`,
        });
        const data = response.data || {};
        if (data.url) {
          window.location.href = data.url;
          return;
        }
        throw new Error('Payment link unavailable');
      } catch (err) {
        console.error(err);
        setError(err);
      }
    };
    resolvePayment();
  }, [api, paymentId, pristine]);

  return (
    <>
      <HtmlHead repairy />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        {error && (
          <p>
            Opps! Seems like we cant provide you a service now.
            Please contact support if problem persists
          </p>
        )}
        {!error && (
          <img
            alt="rpry-icon"
            src="/rpry-icon.svg"
            className={css.RpryLogo}
          />
        )}
      </div>
    </>
  );
};
